import React from 'react';
import axios from 'axios';
import {Boton, Accion} from '../comun/Index';
import Nueva from './Nueva';
const FileDownload = require('js-file-download');

const consultaPost = function(url, config, valores) {
  return new Promise(function(resolve, reject) {
    console.log(valores)
    axios.post(localStorage.getItem('apiUrl') + url, valores, config)
    .then((resul) => {
      if (resul.data.status === "ok"){
        console.log(resul.data.resultados)
        console.log("resolve")
        resolve();
      } else {
        console.log("resul.data.error")
        reject(resul.data.error);
      }
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    });
  });
}

const asignarCoordenasPost = function(valores){
  return new Promise(function(resolve, reject) {
    const url = '/api/geo/padron/admin/agregar-coordenadas';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    consultaPost(url, config, {personas:valores})
    .then(() => resolve())
    .catch((error) => reject(error))
  });
}

class Paginador extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount(){}

  paginas(total, limit, offset){
    let paginas = [];
    if (offset === 0) offset = 1;
    const cantidad = Math.ceil(parseInt(total)/parseInt(limit));
    const seleccionada = Math.ceil(parseInt(offset)/parseInt(limit));
    console.log(seleccionada)
    for (var i = 1; i <= cantidad; i++) {
      paginas.push({
        id:i,
        seleccionada:seleccionada == i
      })
    }
    return(paginas)
  }
  setOffset(index, limit){
    return(parseInt(index) * parseInt(limit))
  }

  render(){
    const {total, limit, offset, setOffset} = this.props;
    return(
      <div style={{display:'flex', flexDirection:'row', overflow:'hidden', flexWrap:'wrap', alignItems:'center', justifyContent:'center'}}>
        {this.paginas(total, limit, offset).map((item, index) => {
          return(
            <span
              key={index}
              style={{
                padding:'5px 8px',
                margin:2,
                borderStyle:'solid',
                borderRadius:3,
                borderColor:'lightgrey',
                borderWidth:1, color:'black',
                backgroundColor: parseInt(index) === parseInt(offset) / parseInt(limit) ? "lightblue": "white",
                cursor:'pointer'
              }}
              onClick={() => this.props.setOffset(this.setOffset(index, limit))}
            >
              {item.id}
            </span>
          )
        })}
      </div>
    )
  }
}

class Persona extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount(){}

  backgroundColor(estado, error){
    if (error) return("#F24B4B")
    switch (estado) {
      case "SIN ASIGNAR":
        return("white");
      case "PENDIENTE":
        return("#F2AF4B");
      case "RESUELTO":
        return("#2F968B");
        break;
      default:
        return("#F2AF4B");
    }
  }

  render(){
    const {persona, seleccionar, checked,checkear} = this.props;
    return(
      <div
        style={{
          width:'calc(100% - 20px)', padding:10, display:'flex', flexDirection:'row',
          flexWrap:'wrap', alignItems:'center', position:'relative',
          backgroundColor: this.backgroundColor(persona.estado, persona.error)
        }}
      >
        <div style={{paddingRight:30, display:'flex', flexDirection:'column'}}>
          <span>
            <strong>{persona.documento} - </strong>
            {persona.apellidos + ", " + persona.nombres}
            {persona.error ? <strong> (ERROR EN DIRECCIÓN) </strong> : null}
          </span>
          <strong>
          {persona.localidad + " - " + persona.calle + " " + persona.numero}
          </strong>
        </div>
        <div
          style={{
            position:'absolute', right:10, backgroundColor:'white',
            borderRadius:5, padding:3, display:'flex', flexDirection:'row'
          }}
        >
          <Accion
            tamaño={24}
            icono="delete"
            ayuda="Eliminar"
            backgroundColor="red"
            disabled={true}
            onClick={() => this.props.eliminar()}
          />
          <Accion
            tamaño={24}
            icono="add_location"
            ayuda="Asignar coordendas"
            backgroundColor="lightblue"
            disabled={false}
            onClick={() => this.props.asignarCoordenadas()}
          />
          <input
            style={{minWidth:'auto', maring:1, transform: 'scale(1.5)', margin:'0px 7px'}}
            type="checkbox"
            checked={checked}
            onChange={(e)=>checkear(e.target.checked)}
          />
        </div>
      </div>
    );
  }
}

class Listado extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  render(){
    const {padron, seleccionados} = this.props;
    return(
      <div className="Lista">
        {padron.map((item, index) => {
          return(
            <div
              key={index}
              style={{width:'100%', display:'flex', flexDirection:'column', alignItems:'center'}}
            >
              <Persona
                persona={item}
                checked={seleccionados.findIndex((item2) => item2 === item.id) !== -1}
                eliminar={() => this.props.eliminar(item.id)}
                checkear={(estado) => this.props.checkear(item.id, estado)}
                asignarCoordenadas={() => this.props.asignarCoordenadas(item.id)}
              />
              {padron.length-1 !== index &&
                <hr style={{width:'100%', color:'white', padding:0, margin:0}}/>
              }
            </div>
          )
        })}
      </div>
    );
  }
}

export default class Padron extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      padron:[],
      showModal:false,
      datosModal:{},
      seleccionados:[],
      busqueda:null,
      limit:50,
      offset:0,
      total:0
    }
  }

  componentDidMount(){
    this.actualizar();
  }

  async actualizar(busquedaParam = null, offsetParam = null, limitParam = null){
    const url = localStorage.getItem('apiUrl') + '/api/geo/padron/admin/listar';
    const busqueda = busquedaParam === null ? this.state.busqueda === '' ? null : this.state.busqueda : busquedaParam;
    const offset = offsetParam === null ? this.state.offset : offsetParam;
    const limit = limitParam === null ? this.state.limit : limitParam;
    const config = {
      headers:{authorization:sessionStorage.getItem('token')},
      params:{
        busqueda,
        offset,
        limit
      }
    };
    axios.get(url, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        this.setState({
          padron:res.data.padron,
          total:res.data.total,
          datosModal:{},
          showModal:false
        })
      } else {
        alert(res.data.error);
      }
    })
    .catch((err) => {
      console.log(err);
    })
  }

  nuevo(){
    this.setState({showModal:true});
  }

  editar(index){
    this.setState({datosModal:this.state.generos[index]});
    this.setState({showModal:true});
  }

  guardar(datos){
    const url = localStorage.getItem('apiUrl') + '/api/geo/padron/admin/nuevo';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    const consulta={datos};
    axios.post(url, consulta, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        this.actualizar();
      } else {
        alert(res.data.error);
      }
    })
    .catch((err) => {
      console.log(err);
    })
  }

  salir(){
    this.setState({
      datosModal:{},
      showModal:false
    })
  }

  descargar(){
    const url = localStorage.getItem('apiUrl') + "/api/geo/padron/admin/modelo"
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then(res => {
      FileDownload(res.data, "modelo.csv");
    })
    .catch((e) =>{
      console.log(JSON.stringify(e))
    });
  }

  checkear(id, estado){
    let seleccionados = this.state.seleccionados;
    if (estado){
      seleccionados.push(id);
    } else {
      seleccionados.splice(seleccionados.findIndex((item) => item === id), 1)
    }
    this.setState({seleccionados})
  }

  eliminar(id){

  }
  eliminarSeleccionados(){

  }

  asignarCoordenadas(id){
    const valores = [id]
    console.log(valores)
    asignarCoordenasPost(valores)
    .then(() => {
      this.actualizar();
    })
    .catch((error) => console.log(error))
  }

  asignarCoordenadasSeleccionados(){
    const valores = this.state.seleccionados
    asignarCoordenasPost(valores)
    .then(() => {
      this.actualizar();
    })
    .catch((error) => console.log(error))
  }

  setOffset(offset){
    this.setState({offset})
    this.actualizar(null, offset, null);
  }

  render(){
    const {showModal, datosModal, padron, seleccionados, busqueda, total, limit, offset} = this.state;
    return(
      <div className="Todo Configuraciones">
        <div className="TramitesTodo">
          {showModal &&
            <Nueva
              datos={datosModal}
              salir={() => this.salir()}
              guardar={(datos) => this.guardar(datos)}
            />
          }
          <h2>Padrón</h2>
          <div style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between', alignItems:'center', margin:"10px 0"}}>
            <div>
              <input
                type="text"
                value={busqueda}
                onChange={(e) => this.setState({busqueda:e.target.value})}
                placeholder="Busqueda (DNI/Apellidos/Nombres)"
              />
              <Boton
                backgroundColor="orange"
                titulo="Buscar"
                onClick={() => this.actualizar(this.state.busqueda)}
              />
            </div>
            <div style={{backgroundColor:'white',borderRadius:5, padding:3, display:'flex', flexDirection:'row'}}>
              <Accion
                tamaño={24}
                icono="delete"
                ayuda="Eliminar"
                backgroundColor="red"
                disabled={true}
                onClick={() => this.eliminarSeleccionados()}
              />
              <Accion
                tamaño={24}
                icono="add_location"
                ayuda="Asignar coordendas"
                backgroundColor="lightblue"
                disabled={true}
                onClick={() => this.asignarCoordenadasSeleccionados()}
              />
            </div>
          </div>
          <Listado
            seleccionados={seleccionados}
            padron={padron}
            checkear={(id, estado) => this.checkear(id, estado)}
            eliminar={(id) => this.eliminar(id)}
            asignarCoordenadas={(id) => this.asignarCoordenadas(id)}
          />
          {padron.length > 0 &&
            <Paginador
              total={total}
              limit={limit}
              offset={offset}
              setOffset={(offset) => this.setOffset(offset)}
            />
          }
          <div style={{display:'flex', flexDirection:'row'}}>
            <Boton
              backgroundColor="#7600E8"
              titulo="Descargar modelo"
              onClick={() => this.descargar()}
            />
            <Boton
              backgroundColor="#00a5e5"
              titulo="Subir CSV"
              onClick={() => this.nuevo()}
            />
          </div>
        </div>
      </div>
    );
  }
}
